// removed by extract-text-webpack-plugin
module.exports = {"container":"Terms__container___3tOPU","iframe":"Terms__iframe___3KkKL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/types/credit/Terms.less
 ** module id = 776
 ** module chunks = 0
 **/